import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import EndGameOptionsStyled from './EndGameOptions.styled';
import EndGameButton from '../../atoms/EndGameButton/EndGameButton';

const mapStateToProps = state => ({
  roundWin: state.game.roundWin,
});

const EndGameOptions = ({ show, roundWin }) => (
  <CSSTransition in={show} appear timeout={500} classNames="end-game-options">
    <section className="end-game-options">
      <EndGameOptionsStyled show={show}>
        <EndGameButton text="restart" />
        <EndGameButton text="menu" />
        {roundWin && <EndGameButton text="next" />}
      </EndGameOptionsStyled>
    </section>
  </CSSTransition>
);

export default connect(mapStateToProps)(EndGameOptions);

EndGameOptions.propTypes = {
  show: PropTypes.bool,
  roundWin: PropTypes.bool.isRequired,
};

EndGameOptions.defaultProps = {
  show: false,
};



// WEBPACK FOOTER //
// ./src/components/molecules/EndGameOptions/EndGameOptions.js